<template>
  <div class="row">
    <div class="col-sm">
      Contact
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>

<style>


</style>
